export default {
      id: "noPayments-usage",
      viewBox: "0 0 56 56",
      url: __webpack_public_path__ + "sprite.1790760972825.svg#noPayments-usage",
      toString: function () {
        return this.url;
      }
    }